import { AppConstants } from '@/app.constants';
import { InspectionImageType } from '@/enums/InspectionImage.enum';
import { idbStorage } from './idbStorage';



export const imageStorage = {
  getImage: async (inspectionId: string, type: InspectionImageType, id: string): Promise<string> => {
    const data = (await idbStorage.getItem(AppConstants.INDEX_DB.store.images, `${inspectionId}_${type}_${AppConstants.INDEX_DB.store.images}_${id}`)) || null;
    return data;
  },

  setImage: async (inspectionId: string, type: InspectionImageType, id: string, value: string) => {
    await idbStorage.setItem(AppConstants.INDEX_DB.store.images, `${inspectionId}_${type}_${AppConstants.INDEX_DB.store.images}_${id}`, value);
  },

  removeImage: async (inspectionId: string, type: InspectionImageType, id: string) => {
    await idbStorage.removeItem(AppConstants.INDEX_DB.store.images, `${inspectionId}_${type}_${AppConstants.INDEX_DB.store.images}_${id}`);
  },

  removeMultipleItems: async (inspectionId: string, type: InspectionImageType, ids: string[]) => {
    if (ids?.length) {
      const keys = ids.map(i => `${inspectionId}_${type}_${AppConstants.INDEX_DB.store.images}_${i}`);
      await idbStorage.removeMultipleItems(AppConstants.INDEX_DB.store.images, keys);
    }
  },
  clear: async () => {
    idbStorage.clear(AppConstants.INDEX_DB.store.images);
  }
};
